import _ from "lodash";
import {USER_ROLES} from '@/models/Users';

export default {
    data(){
      return{
          companies: [],
          companyName: {},
          userIsAdmin: this.$store.state.userInfo.roles.includes(USER_ROLES.ADMIN)
      }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    methods: {
        getCompanies() {
            let _query = {
                "fullness": "FULL",
                "deleted": false,
                "order": [
                    {
                        "field": "name",
                        "type": "ASC"
                    }
                ],
                "offset": 0,
                "count": 8888
            };
            return this.$services.companies.list(_query).then(resp => {
                this.companies = resp.data.list;
                this.companies.forEach(it => {
                    this.companyName[it.id] = it.name;
                })
            });
        },
        handleShowHelp() {
            window.open(this.$router.resolve({name: 'FAQ'}).href + '/SearchOperators', '_blank');
        },
        handleOpenSearch(keyword, docType='') {
            window.localStorage.setItem('wordStatQuery', JSON.stringify({
                query: keyword,
                docType: docType || this.curType,
                from: 'wordStat'
            }));
            window.open(document.location.origin + this.$store.state.contextUrl + '/', '_blank');
        },

    }
}